function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3226"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3217"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 1",
  cx: 69.763,
  cy: 69.763,
  r: 69.763,
  strokeWidth: 2,
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fill: "none",
  transform: "translate(89.561 54.742)"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3218"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 2",
  cx: 46.899,
  cy: 46.899,
  r: 46.899,
  strokeWidth: 2,
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fill: "none",
  transform: "translate(112.425 77.606)"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3219"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 3",
  cx: 6.916,
  cy: 6.916,
  r: 6.916,
  strokeWidth: 2,
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fill: "none",
  transform: "translate(156.545 132.161)"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3220"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 4",
  cx: 6.916,
  cy: 6.916,
  r: 6.916,
  strokeWidth: 2,
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fill: "none",
  transform: "translate(140.346 126.721)"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3221"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 5",
  cx: 6.916,
  cy: 6.916,
  r: 6.916,
  strokeWidth: 2,
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fill: "none",
  transform: "translate(140.354 108.239)"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3222"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 6",
  cx: 6.916,
  cy: 6.916,
  r: 6.916,
  strokeWidth: 2,
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fill: "none",
  transform: "translate(157.447 103.111)"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3223"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 7",
  cx: 6.916,
  cy: 6.916,
  r: 6.916,
  strokeWidth: 2,
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fill: "none",
  transform: "translate(167.423 118.636)"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3224"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2856",
  d: "M159.668 12.808l14.3.937-.17 2.611.51-2.567 14.052 2.8-.51 2.567.841-2.478 13.566 4.604-.841 2.478 1.157-2.347 12.85 6.337-1.157 2.347 1.455-2.176 11.913 7.96-1.455 2.176 1.726-1.968 10.772 9.448-1.724 1.968 1.967-1.726 9.447 10.772-1.967 1.726 2.176-1.453 7.961 11.913-2.176 1.453 2.347-1.158 6.338 12.852-2.348 1.157 2.478-.841 4.605 13.567-2.478.841 2.567-.51 2.795 14.052-2.567.511 2.612-.172.937 14.3-2.611.172 2.611.17-.937 14.3-2.612-.17 2.567.509-2.795 14.054-2.567-.511 2.478.842-4.605 13.568-2.478-.842 2.348 1.158-6.336 12.843-2.347-1.158 2.176 1.455-7.961 11.913-2.176-1.455 1.967 1.726-9.447 10.772-1.967-1.725 1.724 1.968-10.772 9.446-1.726-1.967 1.455 2.176-11.913 7.96-1.455-2.176 1.157 2.347-12.85 6.338-1.157-2.348.841 2.478-13.568 4.605-.841-2.478.51 2.567-14.05 2.796-.51-2.567.17 2.613-14.3.937-.17-2.611-.172 2.611-14.3-.937.172-2.613-.511 2.567-14.052-2.795.509-2.567-.841 2.478-13.567-4.605.842-2.478-1.158 2.348-12.851-6.338 1.157-2.347-1.453 2.176-11.913-7.96 1.453-2.176-1.726 1.967-10.771-9.443 1.726-1.968-1.969 1.725-9.446-10.772 1.968-1.726-2.176 1.455-7.961-11.914 2.176-1.455-2.347 1.158-6.337-12.85 2.347-1.158-2.478.842-4.605-13.568 2.478-.842-2.567.511-2.8-14.054 2.567-.509-2.612.17-.937-14.3 2.611-.17-2.611-.172.937-14.3 2.612.172-2.567-.511 2.8-14.052 2.567.51-2.478-.841 4.605-13.567 2.478.841-2.347-1.157 6.337-12.852 2.347 1.158-2.176-1.453 7.96-11.913 2.176 1.453-1.968-1.726 9.446-10.772 1.969 1.726-1.726-1.968 10.772-9.448 1.726 1.968-1.452-2.171 11.913-7.96 1.453 2.176-1.157-2.347 12.851-6.337 1.158 2.347-.842-2.478 13.571-4.609.841 2.478-.509-2.567 14.052-2.8.511 2.567-.172-2.611 14.3-.937.172 2.612z",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3225"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2857",
  d: "M317 173.251h-32.534a131.275 131.275 0 10-249.487 0H1",
  fill: "none",
  stroke: "#b7b7b7",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})));

function SvgTireCloseUpGraphic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 310,
    height: 238.104,
    viewBox: "0 0 318 238"
  }, props), _ref);
}

export default SvgTireCloseUpGraphic;